import UNIQUE from '@/common/unique'
import columnDetail from '../columnDetail'
export default {
  id: 'qrcode',
  name: 'qrcode',
  type: 'standard',
  moduleName: 'editor_module_qrcode',
  dataSet: {
    mods: 'flexible',
    column: [
      {
        columnId: UNIQUE.mid(),
        flex: 1,
        type: 'qrcode',
        value: null,
        detail: {
          options: ['qrcode', 'qrcodeSize', 'qrcodeExpired', 'colorHex', 'border', 'background', 'padding', 'radius'],
          qrcode: columnDetail.qrcode,
          size: columnDetail.qrcodeSize,
          colorHex: columnDetail.colorHex,
          border: columnDetail.border,
          background: columnDetail.background,
          padding: columnDetail.padding,
          radius: columnDetail.radius
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'link',
        'columns',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
